
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/webinars",
      function () {
        return require("private-next-pages/cleartax.in/webinars/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/webinars"])
      });
    }
  